export const downloadFile = (
  content: string,
  fileName: string,
  fileType: string | undefined = 'text/yaml',
) => {
  const textToWriteBlob = new Blob([content], {
    type: fileType,
  });
  const textToWriteUrl = URL.createObjectURL(textToWriteBlob);
  const downloadLink = document.createElement('a');
  downloadLink.download = fileName;
  downloadLink.href = textToWriteUrl;
  downloadLink.click();
  downloadLink.remove();
  URL.revokeObjectURL(downloadLink.href);
};

export const copyToClipboard = async (text: string) => {
  await navigator.clipboard.writeText(text);
};

export const saveYaml = (filename: string, yamldata: string) => {
  downloadFile(yamldata, `${filename}.yaml`, 'application/yaml');
};

export const saveJson = (data: any, filename = 'data.json') => {
  const jsonStr = JSON.stringify(data, null, 2);
  downloadFile(jsonStr, filename, 'application/json');
};

export const downloadFileFromServer = (
  url: string,
  options?: { openNewTab: boolean },
) => {
  const downloadLink = document.createElement('a');
  if (options?.openNewTab) {
    downloadLink.target = '_blank';
    downloadLink.rel = 'noopener noreferrer';
  }
  downloadLink.href = url;
  downloadLink.download = '';
  downloadLink.click();
  downloadLink.remove();
};
